import { baseFCMNotification } from "../../../../api/base/baseUrl";

export async function sendBookingRiderNotificationRequest(payload) {
  try {
    const response = await baseFCMNotification.post(
      "/api/v1/booking/rider/by-vehicle",
      payload,
      { headers: { "Content-Type": "application/json" } },
    );

    return { success: true, data: response.data.data, error: null };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: "PEDIDO CREADO, PERO NO SE PUDIERON ENVIAR LAS NOTIFICACIONES",
    };
  }
}
